import { Layout, Tag, type TagProps, Tooltip } from '@loadsmart/miranda-react'

import { type ShipmentTag } from '../domain/ShipmentTag'
import { getTagVariantFromHex } from '../presenter/shipmentTagPresenter'

export type ShipmentTagsProps = {
  tags?: Array<ShipmentTag>
  size?: TagProps['size']
}

export function ShipmentTags({ tags, size = 'default' }: ShipmentTagsProps) {
  if (!tags?.length) return null

  const [first, ...rest] = tags
  const variant = getTagVariantFromHex(first.color)
  const extraCount = rest.length
  const extraTags = rest.map(tag => tag.name).join(', ')
  const counterLabel = `+${String(extraCount)}`

  return (
    <Layout.Group
      gap="spacing-1"
      align="center"
      style={{ flexWrap: 'nowrap' }}
      data-testid="shipment-tags"
    >
      <Tag size={size} title={first.name} variant={variant}>
        {first.name}
      </Tag>
      {extraCount > 0 && (
        <Tooltip placement="top" message={extraTags}>
          <Tag
            size={size}
            data-testid="shipment-tags-counter"
            aria-label={`${String(tags.length)} tags`}
            variant={variant}
          >
            {counterLabel}
          </Tag>
        </Tooltip>
      )}
    </Layout.Group>
  )
}
